import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        layout: 'full'
      },
    },
    {
      path: '/defi',
      name: 'defi',
      component: () => import('@/views/defi/Defi.vue'),
      meta: {
        pageTitle: 'DeFi Overview',
      },
    },
    {
      path: '/reffinance',
      name: 'reffinance',
      component: () => import('@/views/defi/RefFinance.vue'),
      meta: {
        pageTitle: 'Ref Finance',
      },
    },
    {
      path: '/burrow',
      name: 'burrow',
      component: () => import('@/views/defi/Burrow.vue'),
      meta: {
        pageTitle: 'Burrow Cash',
      },
    },
    {
      path: '/metapool',
      name: 'metapool',
      component: () => import('@/views/defi/MetaPool.vue'),
      meta: {
        pageTitle: 'Meta Pool Liquid Staking',
      },
    },
    {
      path: '/nft',
      name: 'nft',
      component: () => import('@/views/nfts/Nfts.vue'),
      meta: {
        pageTitle: 'NFTs on NEAR',
      },
    },
    {
      path: '/decentralization',
      name: 'gov',
      component: () => import('@/views/governance/Decentralization.vue'),
      meta: {
        pageTitle: 'Staking and Decentralization',
      },
    },
    {
      path: '/wallets',
      name: 'wallets',
      component: () => import('@/views/governance/Wallets.vue'),
      meta: {
        pageTitle: 'Wallets Analysis',
      },
    },
    {
      path: '/glossary',
      name: 'glossary',
      component: () => import('@/views/glossary/Glossary.vue'),
      meta: {
        pageTitle: 'Glossary',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  const homeCanvas = document.getElementById('canv') || null
  if (appLoading) {
    appLoading.style.display = 'none'
  }
  if(homeCanvas){
    appLoading.style.display = 'none'
  }
})

export default router
